/* Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. */

import { ValidatorFn, Validators } from '@angular/forms';
import ticketValidator from '@touchplan/config/lib/ticket-validators.json';
import { ITicketValidatorType } from './ticket-validator-type';

export const validatorHelper = (
	controlsName: string,
	validationMetadataParam?: ITicketValidatorType
): ValidatorFn[] => {
	const validationMetadata = validationMetadataParam ?? (ticketValidator as ITicketValidatorType);
	const validatorsList = [];
	if (validationMetadata[controlsName]?.required) {
		validatorsList.push(Validators.required);
	}
	if (validationMetadata[controlsName]?.min) {
		validatorsList.push(Validators.min(validationMetadata[controlsName].min));
	}
	if (validationMetadata[controlsName]?.max) {
		validatorsList.push(Validators.max(validationMetadata[controlsName].max));
	}
	return validatorsList;
};
